module.exports = __webpack_public_path__ + "static/foodstandslide-02-min-d084bfe65d156887276c75cbbb3f98a9.jpg";